/**
 * 반응률 — 앱 전체의 셈은 이것 하나다: (좋아요 + 댓글) ÷ 조회 × 100.
 *
 * ⛔ 저장·공유·다운로드를 분자에 더하지 마라 — 화면마다 셈이 갈리면 같은 글이 두 값으로 보인다.
 * ⚠️ 팔로워를 분모로 쓰는 「팔로워당 반응」(발굴 색인 `stats30d.engagementRate`)은 다른 지표다 —
 *   반응이 좋아요+댓글+공유+저장이고 정본은 `src/utils/metrics/follower-engagement.ts` 다. 여기로 합치지 않는다.
 */

/** 화면·툴팁·엑셀 머리에 적는 셈 — 글자를 따로 쓰지 말고 이것을 쓴다 */
export const ENGAGEMENT_RATE_FORMULA = '(좋아요+댓글) ÷ 조회';

/**
 * 반응률(%) — 합계끼리 넣으면 묶음의 반응률이다.
 * @param likes 좋아요(수가 아니면 0)
 * @param comments 댓글(수가 아니면 0)
 * @param views 조회
 * @returns 조회가 0 이하이거나 수가 아니면 `null`
 */
export function engagementRatePct(likes: unknown, comments: unknown, views: unknown): number | null {
  const v = Number(views);
  if (!Number.isFinite(v) || v <= 0) return null;
  const l = Number(likes);
  const c = Number(comments);
  return (((Number.isFinite(l) ? l : 0) + (Number.isFinite(c) ? c : 0)) / v) * 100;
}

/**
 * 지표 묶음(`likeCount`·`commentCount`·`viewCount`) 하나의 반응률(%).
 * @returns 조회가 없으면 `null`
 */
export function engagementRatePctOf(m: { likeCount?: unknown; commentCount?: unknown; viewCount?: unknown } | null | undefined): number | null {
  return engagementRatePct(m?.likeCount, m?.commentCount, m?.viewCount);
}
